import { Params } from '@angular/router';

export const convertQueryParamsToString = (query: Params) => {
  let queryString = '?';
  Object.entries(query).forEach(([key, value]) => {
    queryString += `${key}=${value}&`;
  });
  queryString = queryString.substring(0, queryString.length - 1);
  return queryString;
};
